export default {
  functionKey: "ABS",
  title: "ABS",
  group: "Calcul",
  origin: [],
  target: [],
  description: "Retourne la valeur absolue d'un nombre. (Ex: ABS(-5) -> 5)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const jsCode = `${destination} = Math.abs(${origin});`;
    const safeCode = `
    if (!isNaN(parseFloat(${origin}))) {
      ${jsCode}
    } else {
      ${destination} = '';
    }`;
    return { displayCode: jsCode, safeCode };
  }
}
